import React from 'react';
import ReactDOM from 'react-dom';
import Popper from 'popper.js';
import {ReferralWithMyOrgOffers} from '../../providerapp/hook/useReferralQueryForProvider$';
import {formatDateStr} from 'common/util/date';

type Props = {
    requests: ReferralWithMyOrgOffers['incompleteReferralInquiryRequests'];
}

export function InquiryRequestIcon({requests}: Props) {
    const [tooltipShow, setTooltipShow] = React.useState(false);
    const btnRef = React.useRef(null);
    const tooltipRef = React.useRef(null);
    const popperInstance = React.useRef<Popper | null>(null);

    if (!requests?.length) return null;

    const first = requests[0];

    const openTooltip = () => {
        if (popperInstance.current) {
            popperInstance.current.destroy();
            popperInstance.current = null;
        }
        if (btnRef.current && tooltipRef.current) {
            popperInstance.current = new Popper(btnRef.current, tooltipRef.current, {
                placement: 'top',
                modifiers: {
                    flip: { behavior: ['top', 'bottom', 'right'] },
                    preventOverflow: {
                        boundariesElement: 'viewport'
                    },
                    offset: { offset: '0, 8' }
                }
            });
        }
        setTooltipShow(true);
    };

    const closeTooltip = () => {
        setTooltipShow(false);
    };

    return (
        <>
            <span
                ref={btnRef}
                onMouseEnter={openTooltip}
                onMouseLeave={closeTooltip}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    border: '3px solid #F76808',
                    color: '#F76808',
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: 2,
                    flexShrink: 0,
                    cursor: 'default',
                    userSelect: 'none',
                }}
            >
                ?
            </span>
            {ReactDOM.createPortal(
                <div
                    className={
                        (tooltipShow ? '' : 'hidden ') +
                        'border-0 block font-normal leading-normal text-left no-underline break-words rounded-lg shadow-lg'
                    }
                    style={{backgroundColor: '#1e293b', minWidth: '200px', zIndex: 10000, position: 'absolute'}}
                    ref={tooltipRef}
                >
                    <div className='text-white text-sm px-4 py-3'>
                        {first.caseNumber && (
                            <div className='font-semibold mb-1'>Request Number {first.caseNumber}</div>
                        )}
                        <div>Submitted On {formatDateStr(first.submittedDate)}</div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
}
